import type { ResponseItem } from '@app/src/types/resourceExplorer'

export enum SuggestionSource {
  PreviousAnswer = 'PreviousAnswer',
  PublicData = 'PublicData',
  Document = 'Document',
}

export type AppliedSuggestion = {
  source: SuggestionSource
  fileNames?: string[]
}

export const getPreviousAnswerSource = (previousAnswer: ResponseItem): SuggestionSource =>
  previousAnswer.isScraped ? SuggestionSource.PublicData : SuggestionSource.PreviousAnswer

/* A question offers at most two sources: its previous answer (a real previous answer or scraped
   public data, whichever the finder kept) and one AI document suggestion. Public data and a
   document are independent, so both surface when both are available. */
export const getAvailableSources = (
  previousAnswer?: ResponseItem,
  hasDocumentSuggestion = false,
): SuggestionSource[] => {
  const sources: SuggestionSource[] = []

  if (previousAnswer && !previousAnswer.isScraped) sources.push(SuggestionSource.PreviousAnswer)
  if (previousAnswer?.isScraped) sources.push(SuggestionSource.PublicData)
  if (hasDocumentSuggestion) sources.push(SuggestionSource.Document)

  return sources
}

export const isAiSource = (source: SuggestionSource): boolean => source !== SuggestionSource.PreviousAnswer
